import { render, staticRenderFns } from "./editFilmVersionRecord.vue?vue&type=template&id=d8ec08a8&"
import script from "./editFilmVersionRecord.vue?vue&type=script&lang=js&"
export * from "./editFilmVersionRecord.vue?vue&type=script&lang=js&"
import style0 from "./editFilmVersionRecord.vue?vue&type=style&index=0&lang=scss&scope=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports